

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService, PrimeNGConfig } from "primeng/api";
import { getStorage, ref, getBlob, uploadBytes } from "firebase/storage";


import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { UtentiService } from "src/app/services/utenti.service";
import { Azienda } from "../../../models/fragile/azienda.model";
import { AziendeService } from "src/app/services/aziende.service";
import { UtilService } from "src/app/services/util.service";
import { Progetto } from "src/app/models/fragile/progetto.model";
import { ProgettiService } from "src/app/services/progetti.service";
import { noSpacesValidator } from "src/app/shared/no-space.validator";
import { Progetto_Firestore } from "src/app/models/firestore/progettoFirestore.model";
import { UploadEvent } from "primeng/fileupload";


@Component({
  templateUrl: "./carica-template-qgis.component.html",
  styleUrls: ["../home.component.css"],
  providers: [MessageService]
})
export class CaricaTemplateQGISComponent implements OnInit {
  protected _onDestroy         = new Subject<void>();

  protected qgisFile: File;
  protected isFileUploaded: boolean = false;
  protected isLoadingFile: boolean = false;
  protected label:string="Cerca file QGIS";
  protected icona:string="pi pi-map-marker";
  protected stile:string="btn-choose-qgisFile";
  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private aziendeService: AziendeService,
    private progettiService: ProgettiService,
    private messageService: MessageService,
    private _formBuilder: FormBuilder,
    private primeConfig: PrimeNGConfig,
  ) {
  }

  ngOnInit(): void {
   
  }

 
  
  onQGISFileSelect($event: { files: File[]; }) {
    this.isLoadingFile= true;
  }
  onQGISFileUpload($event: { files: File[]; }) {
    this.qgisFile = $event.files[0];
    this.label=this.qgisFile.name + " ("+this.formatSize(this.qgisFile.size) +")";
    this.isLoadingFile= false;
    this.isFileUploaded = true;
  }

  formatSize(bytes) {
    const k = 1024;
    const dm = 3;
    const sizes = this.primeConfig.translation.fileSizeTypes;
    if (bytes === 0) {
        return `0 ${sizes[0]}`;
    }
  
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  
    return `${formattedSize} ${sizes[i]}`;
  }
  

  async conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      
      try {
        // Ottieni un riferimento allo storage
        const storage = getStorage();
        const pathReferenceTemplateCaricamenti = ref(storage, "templates/progetto.qgs");
        
        
        // Carica il file sovrascritto
        await uploadBytes(pathReferenceTemplateCaricamenti, this.qgisFile);
        
        
        // Chiudi il dialog con successo e eventualmente passa l'URL
        this.dialogRef.close({ 
          success: true
        });
        
      } catch (error) {
        console.error("Errore durante il caricamento del nuovo file di template del progetto:", error);
        this.dialogRef.close({ 
          success: false, 
          error: error 
        });
      }
    }
  }
}
